import paymentProcessing from './paymentProcessing'
import productDetails from './productDetails'
import passengers from './passengers'

export default {
  namespaced: true,
  modules: { productDetails, passengers, paymentProcessing },
}
